import { Cascader } from 'antd';
import { IBCCascaderProps } from './entities';

const BCCascader = (props: IBCCascaderProps<any, any>) => (
	<Cascader
		disabled={props.disabled}
		dropdownMenuColumnStyle={props.dropdownMenuColumnStyle}
		dropdownRender={props.dropdownRender}
		displayRender={props.displayRender}
		tagRender={props.tagRender}
		allowClear={props.allowClear}
		className={props.className}
		style={props.style}
		maxTagCount={props.maxTagCount}
		onChange={props.onChange as any}
		showSearch={props.showSearch}
		value={props.value}
		multiple={props.multiple}
		options={props.options}
		size={props.size}
		suffixIcon={props.suffixIcon}
		optionRender={props.optionRender}
	/>
);
export default BCCascader;

export { IBCCascaderProps };
